/* 消息路由 */
export const MESSAGE_ROUTE = [
    {templateCode: 'flow_notice', path: '/flow/task/todo/detail/index'},
    {templateCode: 'purchase_order', path: '/purchase/order/detail'},
    {templateCode: 'sales_order', path: '/sales/order/detail'},
    {templateCode: 'work_order', path: '/production/work-order/detail'},
    {templateCode: 'warehouse_alert', path: '/warehouse/alert/detail'},
    {templateCode: 'quality_report', path: '/quality/report/detail'},
    {templateCode: 'equipment_alarm', path: '/equipment/alarm/detail'},
    {templateCode: 'andon_call', path: '/andon/call/detail'},
    {templateCode: 'system_announcement', path: '/system/announcement/detail'},
    {templateCode: 'urgent_notice', path: '/system/notice/detail'}
]

// 消息类型图标映射
export const MESSAGE_TYPE_ICONS = {
    'flow_notice': 'el-icon-s-order',
    'purchase_order': 'el-icon-shopping-bag-1',
    'sales_order': 'el-icon-sell',
    'work_order': 'el-icon-setting',
    'warehouse_alert': 'el-icon-warning-outline',
    'quality_report': 'el-icon-document-checked',
    'equipment_alarm': 'el-icon-warning',
    'andon_call': 'el-icon-phone',
    'system_announcement': 'el-icon-bell',
    'urgent_notice': 'el-icon-message-solid',
    'default': 'el-icon-message'
}

// 消息优先级配置
export const MESSAGE_PRIORITY = {
    'HIGH': {
        label: '高',
        color: '#F56C6C',
        icon: 'el-icon-warning'
    },
    'NORMAL': {
        label: '普通',
        color: '#409EFF',
        icon: 'el-icon-info'
    },
    'LOW': {
        label: '低',
        color: '#909399',
        icon: 'el-icon-minus'
    }
}

/**
 * 获取路由path
 * @param templateCode 模板编码
 * @returns {string} 路由path
 */
export function getRoutePath (templateCode) {
    const route = MESSAGE_ROUTE.find(item => item.templateCode === templateCode)
    // 为空可以考虑返回404页面
    return route ? route.path : ''
}

/**
 * 获取消息类型图标
 * @param templateCode 模板编码
 * @returns {string} 图标类名
 */
export function getMessageIcon (templateCode) {
    return MESSAGE_TYPE_ICONS[templateCode] || MESSAGE_TYPE_ICONS['default']
}

/**
 * 获取消息优先级配置
 * @param priority 优先级
 * @returns {object} 优先级配置
 */
export function getMessagePriority (priority) {
    return MESSAGE_PRIORITY[priority] || MESSAGE_PRIORITY['NORMAL']
}



// WEBPACK FOOTER //
// ./src/const/andon/messageConst.js